<template>
  <v-card outlined class="pa-2 mx-4 mb-6 elevation-0">
    <v-row>
      <v-col cols="6">
        <v-col cols="12">
          <h2>Cảnh báo</h2>
        </v-col>
      </v-col>
    </v-row>
    <div class="ml-6">
      <div style="color: #1a0dab; cursor: pointer" class="ml-2">Danh sách học sinh nợ học phí tháng 07/2024</div>
    </div>
    <div class="ml-6 pb-3">
      <div style="color: #1a0dab; cursor: pointer" class="ml-2">Danh sách giáo viên tăng lương tháng 07/2024</div>
    </div>
  </v-card>
</template>

<script>
export default {}
</script>

<style></style>
